const template = document.createElement("template");
template.innerHTML = `
      <style>

      i {
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
        -webkit-font-smoothing: antialiased;
        display: inline-block;
        font-style: normal;
        font-variant: normal;
        text-rendering: auto;
        line-height: 1;
        padding: 0.25rem 0  0.25rem  0.5rem;
        user-select: none;
        position: absolute;
        top: 0;
        right: 0;
        padding: 6px 12px 6px 6px;;
      }
      i::before {
        content: '\\f002';
        font-family: 'Font Awesome 5 Free';
        color: #0066A1;
    }
      </style>
      <i></i>
    `;
export class SearcherMagnifierElement extends HTMLElement {
    private _shadowRoot: ShadowRoot;
    private element: HTMLElement;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
        this._shadowRoot.appendChild(template.content.cloneNode(true));
        this.setAttribute("data-s6-focusable", "true");
        this.element = this._shadowRoot.querySelector("i");
    }

    private connectedCallback() {
        this.upgradeProperty("readOnly");
    }
    private upgradeProperty(prop) {
        if (this.hasOwnProperty(prop)) {
            let value = this[prop];
            delete this[prop];
            this[prop] = value;
        }
    }

    public set readOnly(ro: boolean) {
        if (ro) {
            this.element.style.display = "none";
        } else {
            this.element.style.display = "block";
        }
    }
}

export function initSearcherMagnifierElementWebComponent() {
    window.customElements.define("s6-searcher-magnifier", SearcherMagnifierElement);
}
